import { DataCache } from "./data.cache";
import { DataService } from "../../service/data/data.service";
import { Endpoint } from "@xanadu/model";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class EndpointCache extends DataCache<Endpoint> {

    constructor(
        dataService: DataService
    ) {
        super(Endpoint, dataService);
    }
}
